export const info = [
  {
    title:
    `Prueba Gratis por un Mes`,
    text:
    `    ✓ Crear Tienda
    ✓ Crear productos
    ✕ Editar Información
    ✕ Eliminar Información`,
    price:
    `$0/Mes`,
  },
  {
    title:
    `Suscripción Básica`,
    text:
    `    ✓ Crear Tienda
    ✓ Crear productos
    ✓ Editar Información
    ✕ Eliminar Información`,
    price:
    `$30/Mes`,
  },
  {
    title:
    `Suscripción Premium`,
    text:
    `    ✓ Crear Tienda
    ✓ Crear productos
    ✓ Editar Información
    ✓ Eliminar Información`,
    price:
    `$50/Mes`,
  }
];